import React, { useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { withPrefix } from 'gatsby';

export default function ManagementTeam() {
  const [activeArea, setActiveArea] = useState(null);
  const people = [
    'Gita Gopinath',
    'Bo Li',
    'Kristalina Georgieva',
    'Kenji Okamura',
    'Antoinette Sayeh',
  ];

  const peopleTitle = [
    'First Deputy Managing Director',
    'Deputy Managing Director',
    'Managing Director',
    'Deputy Managing Director',
    'Deputy Managing Director',
  ];

  const mapArea = [
    {
      width: '10%',
      height: '65%',
      left: '13%',
      top: '17%',
    },
    {
      width: '10%',
      height: '65%',
      left: '27%',
      top: '17%',
    },
    {
      width: '10%',
      height: '65%',
      left: '44%',
      top: '17%',
    },
    {
      width: '10%',
      height: '65%',
      left: '59%',
      top: '17%',
    },
    {
      width: '10%',
      height: '65%',
      left: '76%',
      top: '17%',
    },
  ];

  return (
    <Box as='figure' px={{ base: 30, xl: 60 }} mb={{ base: 30, md: 60 }}>
      <Box padding={20} backgroundColor='zinc.100'>
        <Box position='relative' overflow='hidden'>
          {mapArea.map((area, index) => (
            <Box
              as='div'
              key={index}
              position='absolute'
              width={area.width}
              height={area.height}
              left={area.left}
              top={area.top}
              zIndex='1'
              onMouseOver={() => setActiveArea(index)}
              onMouseOut={() => setActiveArea(null)}
              aria-controls='person-info'
              cursor='pointer'
            />
          ))}
          <img src={`${withPrefix('/')}management-team.jpg`} alt='Management Team' />
          <Box
            position='absolute'
            bottom='0'
            left='0'
            width='100%'
            padding={20}
            background='rgba(0,0,0,.5)'
            color='white'
            zIndex='2'
            textAlign='center'
            transform={activeArea !== null ? 'translateY(0)' : 'translateY(100%)'}
            transition='transform 0.25s ease-in'
            id='person-info'
            aria-live='polite'
          >
            <Text fontSize='md' fontWeight='600' textTransform='uppercase'>
              {people[activeArea] || ' '}
            </Text>
            <Text fontSize='sm' fontWeight='normal'>
              {peopleTitle[activeArea] || ' '}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box maxWidth='container.sm' px={20} mx='auto' mt={20}>
        <Box as='figcaption'>
          <Text fontSize='sm'>
            From left to right: First Deputy Managing Director: GITA GOPINATH, Deputy Managing
            Director: BO LI, Managing Director: KRISTALINA GEORGIEVA, Deputy Managing Director:
            KENJI OKAMURA, Deputy Managing Director: ANTOINETTE SAYEH.
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
